import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.search";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction, postAction } from '@/api/manage';
import { encryption } from '@/utils/encryption/aesEncrypt';
import Vue from 'vue';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { unbindWechat } from '@/api/login';
export default {
  data: function data() {
    return {
      form: this.$form.createForm(this),
      formLogin: {
        username: '',
        password: ''
      },
      unionId: '',
      openId: '',
      state: '',
      tenantId: 0,
      show: true,
      validatorRules: {
        username: {
          rules: [{
            required: true,
            message: '请输入用户名!',
            validator: 'click'
          }]
        },
        password: {
          rules: [{
            required: true,
            message: '请输入密码!',
            validator: 'click'
          }]
        } // captcha:{rule: [{ required: true, message: '请输入验证码!'}]},
        // inputCode:{rules: [{ required: true, message: '请输入验证码!'},{validator: this.validateInputCode}]}

      }
    };
  },
  created: function created() {
    document.domain = 'yesep.online';
    this.show = true;
    var param = window.location.search.substring(1);

    if (param.length > 100) {
      Vue.ls.set(ACCESS_TOKEN, param, 7 * 24 * 60 * 60 * 1000);
      window.sessionStorage.setItem('token', param);
      getAction('/auth/getUserInfo', {}).then(function (res) {
        // let message = { res }
        // window.postMessage(message, 'https://yesep.online')
        console.log('createdDomain');
        document.domain = 'yesep.online';
        window.opener.changeNav(res);
      });
    } else {
      var params = param.split('&');

      if (params && params.length > 0) {
        var index = 0;

        if (params[0] == 'success') {
          this.show = false;
          index = 1;
        }

        this.unionId = params[index];
        this.openId = params[index + 1];
        this.state = params[index + 2];
      }
    }
  },
  methods: {
    onToUnBind: function onToUnBind() {
      var _this = this;

      this.$confirm({
        title: '提示',
        content: '确定解绑?',
        onOk: function onOk() {
          unbindWechat({
            unionId: _this.unionId
          }).then(function (res) {
            if (res.success) {
              _this.$notification.success({
                message: '解绑成功!'
              });

              _this.show = true;
            } else {
              _this.$notification.info({
                message: res.message
              });
            }
          });
        }
      });
    },
    check: function check() {
      var _this2 = this;

      var that = this;
      var loginParams = {
        unionId: this.unionId,
        openId: this.openId,
        state: this.state,
        tenantId: this.tenantId
      }; // 使用账户密码登陆

      that.form.validateFields(['username', 'password'], {
        force: true
      }, function (err, values) {
        console.log(err, values);

        if (!err) {
          getAction('/auth/getTenantByUserName', {
            userName: values.username
          }).then(function (data) {
            if (data.success) {
              _this2.tenantId = data.result.id;
              loginParams.tenantId = data.result.id;
              getAction('/auth/getEncryptedString', {}).then(function (res) {
                loginParams.username = values.username;
                loginParams.password = encryption(values.password, res.result.key, res.result.iv);
                postAction('/auth/bindWechat', loginParams).then(function (res) {
                  if (res.success) {
                    if (that.state == 'open') {
                      console.log('methodDomain');
                      document.domain = 'yesep.online';
                      window.opener.changeNav(res); // let message = {
                      // 	res
                      // }
                      // window.postMessage(message, 'https://yesep.online')
                    } else {
                      that.show = false;
                    }
                  } else {
                    that.requestFailed(res);
                  }
                }).catch(function (err) {
                  that.requestFailed(err);
                });
              }).catch(function (err) {
                that.requestFailed(err);
              });
            } else {
              that.$notification['error']({
                message: '登录失败',
                description: data.message,
                duration: 1 * 1000
              });
              setTimeout(function () {
                _this2.loginBtn = false;
              }, 2000);
            }
          }).catch(function (err) {
            that.requestFailed(err);
          });
        }
      });
    },
    requestFailed: function requestFailed(err) {
      var _this3 = this;

      this.$notification['error']({
        message: '登录失败',
        description: ((err.response || {}).data || {}).message || err.message || '请求出现错误，请稍后再试',
        duration: 4
      });
      setTimeout(function () {
        _this3.loginBtn = false;
      }, 2000);
    },
    handleUsernameOrEmail: function handleUsernameOrEmail(rule, value, callback) {
      var regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/;

      if (regex.test(value)) {
        this.loginType = 0;
      } else {
        this.loginType = 1;
      }

      callback();
    }
  }
};